import styled from "@emotion/styled";
import Fab from "@mui/material/Fab";

const PlayerDelete = styled(Fab)`
  transform: translateX(100%);
  opacity: 0;
  position: absolute !important;
  top: 8px;
  right: 8px;
  width: 36px !important;
  height: 36px !important;
  min-height: 36px !important;
  background-color: #f44336 !important;
  color: white !important;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    background-color 0.2s ease,
    scale 0.2s ease !important;
  box-shadow: none !important;
  border: none;

  &:hover {
    background-color: #d32f2f !important;
    scale: 1.05 !important;
  }

  &:active {
    scale: 0.95 !important;
    background-color: #b71c1c !important;
  }

  svg {
    font-size: 18px;
  }
`;

export default PlayerDelete;
